import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardTrend } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

export type DashboardTrendVariant = 'compact' | 'extended';

@Component({
  selector: 'l-dashboard-trend-list',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './dashboard-trend-list.component.html',
})
export class DashboardTrendListComponent {

  @Input({ required: true })
  public trends: DashboardTrend[] = [];

  @Input()
  public variant: DashboardTrendVariant = 'compact';

}
